export default __webpack_public_path__ + "static/media/goGreenDesktop.d83fd523.svg";